module.exports = __webpack_public_path__ + "assets/img/pz2.5e9260cd.png";